module.exports = __webpack_public_path__ + "img/Homebg_light.7d0fedd9.jpg";